import axios from "axios";
import { SEEN_ENTITIES } from "../endpointsConst";

const SeenEntityService = {};

SeenEntityService.markAsSeen = (entityId) => axios.post(`${axios.defaults.baseURL.replace('v1', 'v2')}${SEEN_ENTITIES}`, {
  entity_id: entityId,
});

export { SeenEntityService };
